import React, { MouseEvent, ReactNode } from "react";
import ActionIcon from "./ActionIcon";
import styled from "@emotion/styled";
import { Typography } from "@kaltura/ds-react-components";
import { Plus16Icon, Minus24Icon } from "@kaltura/ds-react-icons";
import { translate } from "@kaltura/mediaspace-shared-utils";

export type ExpansionPanelSummaryProps = {
    summaryId?: string;
    ariaControls?: string;
    children: ReactNode;
    expanded?: boolean;
    onChange?: (event: MouseEvent) => void;
    onClick?: (event: MouseEvent) => void;
};

const StyledSummaryWrapper = styled("h3")(({ theme }) => ({
    display: "flex",
    padding: theme.spacing(1, 0),
    margin: 0,
    minHeight: theme.spacing(4),
}));

const StyledButton = styled("button")(({ theme }) => ({
    width: "100%",
    height: "auto",
    padding: 0,
    margin: 0,
    backgroundColor: "transparent",
    border: "none",
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    textAlign: "start",
    color: theme.palette.text.primary,
    cursor: "pointer",
}));

const StyledMinusIcon = styled(Minus24Icon)(({ theme }) => ({
    width: theme.spacing(2),
    height: theme.spacing(2),
}));

const ExpansionPanelSummary = ({
    children,
    summaryId,
    ariaControls,
    expanded,
    onChange,
    onClick,
    ...other
}: ExpansionPanelSummaryProps) => {
    const handleChange = (event: MouseEvent) => {
        if (onChange) {
            onChange(event);
        }
        if (onClick) {
            onClick(event);
        }
    };

    const childText = React.Children.toArray(children).join(" ");

    return (
        <StyledSummaryWrapper {...other} className="kms-ds-help-page-faq-summary">
            <StyledButton
                onClick={handleChange}
                aria-label={expanded ? translate("Collapse %1", [childText]) : translate("Expand %1", [childText])}
                aria-expanded={expanded}
                aria-controls={ariaControls}
                id={summaryId}
            >
                <Typography variant={"body2Highlight"}>{children}</Typography>
                <ActionIcon icon={expanded ? <StyledMinusIcon /> : <Plus16Icon />} />
            </StyledButton>
        </StyledSummaryWrapper>
    );
};

export default ExpansionPanelSummary;
